// extracted by mini-css-extract-plugin
module.exports = {"live":"liveLabel__live___zIQYS","is-faded":"liveLabel__is-faded___3Wp1X"};